export default __webpack_public_path__ + "static/media/BCMN-logo-dark-gb.0e8d685d.png";